import type { DateTimeValue } from '../../../components/DateTimePicker';

/** Date-only controls must retain the user's local calendar day, not shift to UTC. */
export function calendarDate(value: Date | DateTimeValue | null): Date | null {
  const date = value instanceof Date ? value : value?.date;
  return date && !Number.isNaN(date.getTime()) ? date : null;
}
export function dateParam(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
export function reportError(error: unknown, fallback: string): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  return typeof detail === 'string' ? detail : fallback;
}
export const REPORT_BUTTON = 'px-4 py-2 rounded bg-slate-700 text-white hover:bg-slate-600 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium';
